import { type GetRealClustersResponse } from '@/packages/query-state/shared/types/clusters/ClustersResponse';

import { type TGetClustersForMapResponse_1 } from '@/repositories/generated/shared/search-offers-index/v2/get-clusters-for-map';

export function prepareClusters(response: TGetClustersForMapResponse_1): GetRealClustersResponse {
  return {
    ...response,
    clusters: response.clusters.map(cluster => ({
      ...cluster,
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [cluster.coordinates.lat, cluster.coordinates.lng],
      },
    })),
  };
}
